import { StepType } from '../../main/types/asset/asset.enums.ts';
import { LessonTask } from '../../main/types/asset/lesson.types.ts';

import { StoryWordIndex } from '../slices/story-reading/story-reading.slice.types.ts';

export interface StepLastWordInput {
  task: LessonTask;
  step: number;
}

export const mapStepLastWord = ({ task, step }: StepLastWordInput): StoryWordIndex | null => {
  const steps = task.steps;
  const story = task.story;
  if (!story) return null;

  const currentStep = steps[step];
  // If the current step has a subindex, return the same as the first word
  if (currentStep.subindex !== undefined) {
    return {
      index: currentStep.index!,
      subindex: currentStep.subindex,
    };
  }

  if ([StepType.UserReadSentence, StepType.AppReadSentence, StepType.BothReadSentence].includes(currentStep.stepType)) {
    return {
      index: currentStep.index!,
      subindex: story[currentStep.index!].length - 1,
    };
  } else if (
    [StepType.UserSoundOut, StepType.AppSoundOut, StepType.UserSayFast, StepType.UserSoundOutContinuous].includes(
      currentStep.stepType
    )
  ) {
    return {
      index: currentStep.index!,
      subindex: currentStep?.subindex ?? 0,
    };
  }

  return null;
};
